/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'query-string';
const Categories = [
  {
    id: 0,
    name: 'Tất cả',
  },
  {
    id: 1,
    name: 'Quản trị doanh nghiệp',
  },
  {
    id: 2,
    name: 'Nghiệp vụ cụ thể',
  },
  {
    id: 3,
    name: ' An toàn, an ninh mạng',
  },
  {
    id: 4,
    name: 'SMEs theo ngành, lĩnh vực',
  },
];
const Tabs = {
  'tat-ca': 0,
  'quan-tri-doanh-nghiep': 1,
  'nghiep-vu-cu-the': 2,
  'an-toan-an-ninh-mang': 3,
  'smes-theo-nganh-linh-vuc': 4,
};

const Partner = () => {
  const [platforms, setPlatForms] = useState([]);
  const [tabId, setTabId] = useState();
  const [platformsCategory, setPlatformsCategory] = useState([]);

  useEffect(() => {
    const { cate } = qs.parse(window.location.search);
    let tab = 0;
    if (!cate || !Tabs[cate]) {
      tab = 0;
    } else {
      tab = Tabs[cate];
    }
    axios.get('/api/v1/platforms').then(({ data }) => {
      if (data.success) {
        setPlatForms([...data.payload]);
        if (Math.abs(tab) !== 0) {
          const platformsTab = data.payload.filter((value) => {
            return value.category_id === Math.abs(tab);
          });
          setPlatformsCategory([...platformsTab]);
          setTabId(Math.abs(tab));
          return;
        }
        setTabId(0);
        setPlatformsCategory([...data.payload]);
      }
    });
  }, []);

  const onChangeTabCategory = (id) => {
    if (id === 0) {
      setPlatformsCategory([...platforms]);
      setTabId(id);
      return;
    }
    const platformsTab = platforms.filter((value) => {
      return value.category_id === id;
    });
    setPlatformsCategory([...platformsTab]);
    setTabId(id);
  };

  return (
    <div className='partner pr'>
      <div className='container'>
        <div className='header'>
          <h2 className='title'>
            <span className='black'>Các đơn vị</span>{' '}
            <span className='red'>tham gia</span>
          </h2>
          <p className='des'>
            Danh sách các nền tảng hỗ trợ chuyển đổi số xuất sắc tham gia vào
            chương trình.
          </p>
        </div>
        <ul className='news__tab nav flex'>
          {Categories.map(({ id, name }) => {
            return (
              <li key={id} style={{ cursor: 'pointer' }}>
                <a
                  onClick={(e) => {
                    onChangeTabCategory(id);
                  }}
                  data-toggle='tab'
                  title=''
                  className={id === tabId ? 'active' : ''}
                >
                  {name}
                </a>
              </li>
            );
          })}
        </ul>
        <div className='partner__list row'>
          {platformsCategory.map(
            ({ name, short_description, thumbnail, slug }, index) => {
              return (
                <article
                  className='col-lg-4 col-md-4'
                  onClick={() =>
                    (window.location.href = `/nen-tang-so/${slug}`)
                  }
                  style={{ cursor: 'pointer' }}
                  key={index}
                >
                  <div className='item'>
                    <div className='logo'>
                      <img width='126px' src={thumbnail} alt='' height='64px' />
                    </div>
                    <p
                      style={{
                        display: '-webkit-box',
                        height: '50px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: '2',
                      }}
                    >
                      {short_description}
                    </p>
                    <a
                      href={`/nen-tang-so/${slug}`}
                      title='Chi tiết'
                      className='link_viewmore'
                    >
                      Chi tiết
                    </a>
                  </div>
                </article>
              );
            }
          )}
        </div>
        {/* <a href='/' title='See all' className='btn__seeall flex-center'>
          Xem tất cả
        </a> */}
      </div>
    </div>
  );
};

export default Partner;
